export default __webpack_public_path__ + "static/media/default-cat.d44000f2.jpg";